import {ShiftStartShiftTimelineEvent} from '@ots-frontend/ots-data';
import {ActionIcon, Text} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconCircle} from "@tabler/icons-react";

type Props = {
  event: ShiftStartShiftTimelineEvent;
  onClick?: (event: ShiftStartShiftTimelineEvent) => void
};


export const StartTimelineItemTitle = (props: {}) => {
  const {t} = useTranslation(["common"])
  return <>{t("common.entity.shift.timeline.start.title", "Started")}</>
}

export const StartTimelineItemBullet = (props: Props) => {
  const {event, onClick} = props;

  if (onClick) {
    return (
      <ActionIcon variant="transparent" onClick={() => onClick(event)}>
        <IconCircle size={12}/>
      </ActionIcon>
    )
  } else {
    return (
      <IconCircle size={12}/>
    )
  }
}

export const StartTimelineItem = (props: Props) => {
  const {event} = props;

  return (
    <>
      <Text size="xs" mt={4}>
        <FormattedDateTime date={event.date}/>
      </Text>
    </>
  );
};

StartTimelineItem.Title = StartTimelineItemTitle
StartTimelineItem.Bullet = StartTimelineItemBullet;
